<!--favorites for future-->
<!--<app-core-sidebar-favorites [items]="favorites()" />-->
<mat-list>
  @for (item of items(); track $index) {
    <app-core-sidebar-section class="mat-title-small" [item]="item"/>
  }
</mat-list>







